module.exports = {
    apacheData: () => {
        return[
            {
            "Logo":require("./../../UI/general/Sidebar/logos-motos/tvs-apache.svg"),
            "Motos":[
                {
                    "Nombre":"Apache 160 2V",
                    "Logo":require('./../../UI/general/Sidebar/btns-motos/apache/rtr-160.svg'),
                    "Foto":require('./../../UI/general/Sidebar/btns-motos/apache/rtr-160-moto.png')
                },
                {
                    "Nombre":"Apache 160 4V",
                    "Logo":require('./../../UI/general/Sidebar/btns-motos/apache/rtr-160-4v.svg'),
                    "Foto":require('./../../UI/general/Sidebar/btns-motos/apache/rtr-160-4v-moto.png')
                },
                {
                    "Nombre":"Apache 180 2V",
                    "Logo":require('./../../UI/general/Sidebar/btns-motos/apache/rtr-180.svg'),
                    "Foto":require('./../../UI/general/Sidebar/btns-motos/apache/rtr-180-moto.png')
                },
                {
                    "Nombre":"Apache 200 2V",
                    "Logo":require('./../../UI/general/Sidebar/btns-motos/apache/rtr-200-4v.svg'),
                    "Foto":require('./../../UI/general/Sidebar/btns-motos/apache/rtr-200-4v-moto.png')
                },
                {
                    "Nombre":"Apache 200 fi",
                    "Logo":require('./../../UI/general/Sidebar/btns-motos/apache/rtr-200-fi.svg'),
                    "Foto":require('./../../UI/general/Sidebar/btns-motos/apache/rtr-200-fi-moto.png')
                },
                {
                    "Nombre":"Apache RR 310",
                    "Logo":require('./../../UI/general/Sidebar/btns-motos/apache/apache-rr.svg'),
                    "Foto":require('./../../UI/general/Sidebar/btns-motos/apache/apache-rr-moto.png')
                }
            ]
            }
        ]
    }
}